/**
 * Public app download links.
 *
 * Override with REACT_APP_APP_STORE_URL if the listing URL changes.
 */
export const APP_STORE_URL = String(
  process.env.REACT_APP_APP_STORE_URL ||
    "https://apps.apple.com/us/app/betbond/id6752109430"
).trim();

export const IS_APP_STORE_LIVE = Boolean(APP_STORE_URL);
